// src/hooks/useUserDoc.js
import { useEffect, useState, useCallback } from 'react';
import { useAuth } from './useAuth';
import { getUserDoc } from '../firebase/services';

export const useUserDoc = () => {
  const { user } = useAuth();
  const [userDoc, setUserDoc] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!user) {
      setUserDoc(null);
      setLoading(false);
      return;
    }
    try {
      const doc = await getUserDoc(user.uid);
      setUserDoc(doc);
    } catch (err) {
      console.error('Failed to fetch user doc:', err);
      setUserDoc(null);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { load(); }, [load]);

  const isPremium = userDoc?.tier === 'premium' || userDoc?.tier === 'business';
  const isBusiness = userDoc?.tier === 'business';

  return { userDoc, loading, isPremium, isBusiness, reload: load };
};
